// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"b7d2e6ec","239":"8e889764","455":"ec4aee73","511":"18bfc51e","600":"33417e65","960":"8d6607d9","977":"a5533b8b"}[chunkId] + ".chunk.js";
};